exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".actions-padding[data-v-f6ae92b4]{padding-bottom:19px;padding-left:18px;padding-right:18px}.pt-switch[data-v-f6ae92b4]{padding-top:20px}", "", {"version":3,"sources":["/vercel/path0/src/pages/AdditionalWork.vue"],"names":[],"mappings":"AACA,kCACE,oBAAqB,AACrB,kBAAmB,AACnB,kBAAoB,CACrB,AACD,4BACE,gBAAkB,CACnB","file":"AdditionalWork.vue","sourcesContent":["\n.actions-padding[data-v-f6ae92b4] {\n  padding-bottom: 19px;\n  padding-left: 18px;\n  padding-right: 18px;\n}\n.pt-switch[data-v-f6ae92b4] {\n  padding-top: 20px;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f6ae92b4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/AdditionalWork.vue
// module id = 483
// module chunks = 13